import { permissionsList } from "@/router/types";
import { useAppSelector } from "@/utils/redux";
import * as ramda from "ramda";

export const usePermission = (requiredPermissions: (typeof permissionsList)[keyof typeof permissionsList][]) => {
  const userPermissionsList = useAppSelector(
    (state) => state.user.permissions,
  ) as (typeof permissionsList)[keyof typeof permissionsList][];

  const checkPermissions = ramda.pipe(ramda.difference(requiredPermissions), ramda.isEmpty);

  return checkPermissions(userPermissionsList);
};

// const isGranted = usePermission(['balanceAndWithdraw'])
